const SEARCH_KEY = 'b2b-search';
const PAGE_KEY = 'b2b-page';
const SORT_KEY = 'b2b-sort';

export default {

    saveParams(phrase, phraseType, attributes, categories, producers, page, sort) {
        let params = {phrase: phrase, phraseType: phraseType, attributes: attributes, categories: categories, producers: producers};
        window.localStorage.setItem(SEARCH_KEY, JSON.stringify(params));
        window.localStorage.setItem(PAGE_KEY, JSON.stringify(page));
        window.localStorage.setItem(SORT_KEY, JSON.stringify(sort));
    },

    loadPhrase() {
        let code = window.localStorage.getItem(SEARCH_KEY);
        try {
            if (code) {
                let data = JSON.parse(code);
                return data.phrase ? String(data.phrase) : '';
            }
            return '';
        } catch(err) {
            return '';
        }
    },

    loadPhraseType() {
        let code = window.localStorage.getItem(SEARCH_KEY);
        try {
            if (code) {
                let data = JSON.parse(code);
                return data.phraseType ? String(data.phraseType) : '';
            }
            return '';
        } catch(err) {
            return '';
        }
    },

    loadParams(field) {
        let code = window.localStorage.getItem(SEARCH_KEY);
        try {
            if (code) {
                let data = JSON.parse(code);
                return data[field] ?  data[field] : [];
            }
            return [];
        } catch(err) {
            return [];
        }
    },

    loadPage() {
        try {
            let code = window.localStorage.getItem(PAGE_KEY);
            if (code) {
                return JSON.parse(code);
            }
            return {
                current: 1,
                limit: 25
            };
        } catch(err) {
            return {
                current: 1,
                limit: 25
            };
        }
    },

    loadSort() {
        try {
            let code = window.localStorage.getItem(SORT_KEY);
            if (code) {
                return JSON.parse(code);
            }
            return 'priority';
        } catch(err) {
            return 'priority';
        }
    },

    loadKindList() {
        return window.localStorage.getItem('View-Type') ? window.localStorage.getItem('View-Type') : 'gallery';
    },

    saveKindList(value) {
        window.localStorage.setItem('View-Type', value);

    },

    clear() {
        window.localStorage.removeItem(SEARCH_KEY);
        window.localStorage.removeItem(PAGE_KEY);
        window.localStorage.removeItem(SORT_KEY);
    }
}




// WEBPACK FOOTER //
// ./src/components/products/src/search/SearchStorage.js